import { Box } from '@hivebrite/design-system/Box';
import { FakeLink } from '@hivebrite/design-system/Link';
import { Loader } from '@hivebrite/design-system/Loader';

interface LoadMoreProps {
  isFetching: boolean;
  linkText: string;
  loadMore: () => void;
  loadingText: string;
}

export const LoadMore = ({
  isFetching,
  loadMore,
  loadingText,
  linkText,
}: LoadMoreProps) => {
  if (isFetching) {
    return (
      <Box>
        <Box mr={1} font="body-semibold-asphalt">
          {loadingText}
        </Box>
        <Loader size={15} />
      </Box>
    );
  }

  return <FakeLink onClick={loadMore}>{linkText}</FakeLink>;
};
